const keyvisual = document.getElementById('keyvisual');

const videoSources = {
  large: '/ent/wp-content/themes/ENT/images/front/video_keyvisual.mp4',
  small: '/ent/wp-content/themes/ENT/images/front/video_keyvisual@sp.mp4',
};
export default () => {
  const source = document.createElement('source');
  source.setAttribute('type', 'video/mp4');

  const videoSwitcher = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      source.setAttribute('src', videoSources.small);
      keyvisual.appendChild(source);
    } else {
      source.setAttribute('src', videoSources.large);
      keyvisual.appendChild(source);
    }

    keyvisual.load();

    setTimeout(() => {
      keyvisual.play();
    }, 2500);
  };

  document.addEventListener('DOMContentLoaded', videoSwitcher, false);
};
